import schema from './schema'

export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {

    // $models.timeslotCollection
    timeslot_collection_list: ( $models, $registry, $store ) => {
      // NOT NEEDED
      // timeslot_collection_list - all replaced
      return this.$models.timeslotCollection.subscribeList().itemsSorted;
    },

    timeslot_collection_by_timeslot_collection_id: ( $models, $registry, $store ) => {
      const timeslotCollectionId = -1;
      if ( timeslotCollectionId === -1 ) {
        throw new Error('DO NOT USE')
      }
      // JUST DO:
      return this.$models.timeslotCollection.getNode( timeslotCollectionId )
    },

    // flattened_calendar_data_all: ( $models, $registry, $store ) => {},
    // flattened_calendar_data_all -> calendar? leave, worker
  },
  staticActions: {},
  schema:  schema
};
